/* src/app/components/indicator/risk-results/risk-results.component.css */
.rdf-table-responsive {
  width: 100%;
  overflow-x: auto;
}
.rdf-table-responsive .table {
  width: auto;
  min-width: 100%;
}
.rdf-table-responsive tbody tr > td {
  background-color: var(--bg-surface);
}
.rdf-table-responsive td.table-danger {
  background-color: var(--danger-bg) !important;
  color: var(--danger-strong) !important;
}
.rdf-table-responsive td.table-warning {
  background-color: var(--warning-bg) !important;
  color: var(--warning) !important;
}
.rdf-table-responsive td.table-success {
  background-color: var(--success-bg) !important;
  color: var(--success) !important;
}
.rdf-table-responsive td.text-center.text-muted {
  color: var(--fg-4) !important;
  font-size: 13px;
}
.rdf-pagination-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
  flex-wrap: wrap;
}
.rdf-page-info {
  font-size: 12px;
  color: var(--fg-3);
  white-space: nowrap;
}
.rdf-filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.rdf-filter-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
.rdf-search-input {
  width: 220px;
}
@media (max-width: 767.98px) {
  .rdf-search-input {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  :host ::ng-deep ngb-pagination .page-link {
    padding: 9px 14px;
    min-width: 42px;
    min-height: 42px;
    text-align: center;
    font-size: 14px;
  }
}
.rdf-card-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  padding: 4px 0;
}
.rdf-risk-card {
  background: var(--bg-surface);
  border-radius: var(--radius-md);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.10);
  border-left: 5px solid var(--border);
  padding: 12px 14px;
  overflow: hidden;
}
.rdf-card-red {
  border-left-color: var(--danger);
}
.rdf-card-orange {
  border-left-color: var(--warning);
}
.rdf-card-green {
  border-left-color: var(--success);
}
.rdf-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;
}
.rdf-card-company {
  font-size: 0.95em;
  font-weight: 600;
  color: var(--fg-1);
  flex: 1 1 auto;
}
.rdf-card-score {
  font-size: 1.15em;
  font-weight: 700;
  flex-shrink: 0;
}
.rdf-card-taxid {
  font-size: 0.78em;
  font-family: monospace;
  color: var(--fg-3);
  margin-bottom: 8px;
}
.rdf-card-indicators {
  background: var(--gray-50);
  border-radius: var(--radius-sm);
  padding: 6px 10px;
  margin-bottom: 10px;
}
.rdf-card-ind-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  border-bottom: 1px solid var(--gray-100);
  font-size: 0.82em;
  color: var(--fg-2);
}
.rdf-card-ind-row:last-child {
  border-bottom: none;
}
.rdf-card-ind-name {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}
.rdf-card-ind-score {
  font-weight: 600;
  flex-shrink: 0;
  color: var(--fg-2);
}
.rdf-card-actions {
  display: flex;
  gap: 8px;
}
.rdf-toolbar-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rdf-mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 9px 12px;
  cursor: pointer;
  flex: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  -webkit-user-select: none;
  user-select: none;
}
.rdf-mobile-filter-badge {
  background: var(--navy-600);
  color: var(--fg-on-navy);
  border-radius: var(--radius-md);
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.4;
}
/*# sourceMappingURL=risk-results.component.css.map */
